import PricingContainer from "../../Componant/Ecommerce/Pricing";

const Pricing = () => {
  return (
    <div className="page-body">
      <PricingContainer />
    </div>
  );
};

export default Pricing;
